export default __webpack_public_path__ + "static/media/value.f966cb74.svg";